import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Wrapper = styled.div`
  padding: 21px 10px 0;
  color: ${COLORS.gray60};
  font-size: 16px;
  border-radius: 9px;
  background-color: ${COLORS.line};
`;

export default Wrapper;
